import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Send, X, FileText, Loader2 } from 'lucide-react';
import type { TipoMediaEnvio } from '@/lib/media-validation';

interface MidiaPreviewProps {
  file: File;
  tipoMedia: TipoMediaEnvio;
  /** Ficheiro já carregado no bucket (pré-upload concluído). */
  uploadPronto: boolean;
  /** O pré-upload falhou. */
  uploadErro: boolean;
  enviando: boolean;
  onEnviar: (caption: string) => void;
  onCancelar: () => void;
}

export function MidiaPreview({ file, tipoMedia, uploadPronto, uploadErro, enviando, onEnviar, onCancelar }: MidiaPreviewProps) {
  const { t } = useTranslation();
  const [caption, setCaption] = useState('');
  const [previewUrl, setPreviewUrl] = useState<string | null>(null);

  useEffect(() => {
    if (tipoMedia !== 'image') return;
    const url = URL.createObjectURL(file);
    setPreviewUrl(url);
    return () => URL.revokeObjectURL(url);
  }, [file, tipoMedia]);

  return (
    <div className="painel__midia-preview">
      <div className="painel__midia-preview-head">
        <span className="painel__midia-preview-name">{file.name}</span>
        <button type="button" aria-label={t('panel.media.cancel')} onClick={onCancelar} disabled={enviando}>
          <X size={16} />
        </button>
      </div>
      {tipoMedia === 'image' && previewUrl ? (
        <img src={previewUrl} alt={file.name} className="painel__midia-preview-img" />
      ) : (
        <div className="painel__midia-preview-doc">
          <FileText size={28} />
          <span>{file.name}</span>
        </div>
      )}
      <div className="painel__midia-preview-actions">
        <input
          type="text"
          placeholder={t('panel.media.captionPlaceholder')}
          value={caption}
          onChange={(e) => setCaption(e.target.value)}
          disabled={enviando}
        />
        <button type="button" className="ow-btn ow-btn--outline ow-btn--sm" onClick={onCancelar} disabled={enviando}>
          {t('panel.media.cancel')}
        </button>
        <button
          type="button"
          className="ow-btn ow-btn--primary ow-btn--sm"
          onClick={() => onEnviar(caption)}
          disabled={enviando || !uploadPronto || uploadErro}
        >
          {(enviando || (!uploadPronto && !uploadErro)) ? (
            <Loader2 size={14} className="animate-spin" />
          ) : (
            <Send size={14} />
          )}
          {!uploadPronto && !uploadErro && !enviando ? t('panel.media.uploading') : t('panel.media.send')}
        </button>
      </div>
      {uploadErro && (
        <div className="painel__midia-preview-erro">{t('panel.media.uploadError')}</div>
      )}
    </div>
  );
}
